import * as React from "react";
import { MenuItems } from "../Menu/MenuItems";
import { MenuMobileButton, MenuWrapper } from "./layouts/sidebar.components";
import { MenuInnerWrapper } from "./styled.elements";
import VersionSwitcher from "./VersionSwitcher";
export default function UserMenu(a) {
  var b = a.className,
      c = a.items,
      d = a.navbarHeight,
      e = a.location,
      f = a.apiVersionId,
      g = a.apiVersions,
      h = a.onVersionChange,
      _React$useState = React.useState(!1),
      i = _React$useState[0],
      j = _React$useState[1],
      k = React.useCallback(function () {
    j(!i);
  }, [i]);

  return React.useEffect(function () {
    j(!1);
  }, [e.pathname]), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuMobileButton, {
    opened: i,
    onClick: k
  }), /*#__PURE__*/React.createElement(MenuWrapper, {
    animate: !0,
    opened: i,
    navBarHeight: d,
    className: b
  }, null != f && g && 1 < g.length && /*#__PURE__*/React.createElement(VersionSwitcher, {
    apiVersionId: f,
    apiVersions: g,
    onVersionChange: h
  }) || null, /*#__PURE__*/React.createElement(MenuInnerWrapper, null, /*#__PURE__*/React.createElement(MenuItems, {
    depth: 0,
    items: c
  }))));
}